import type { Health } from '../types';
import styles from './HealthStoplight.module.css';

const LABEL: Record<Health, string> = {
    GREEN: 'On track',
    YELLOW: 'Watch (≤14 days to need)',
    ORANGE: 'Soon (≤7 days to need)',
    RED: 'Overdue or will slip',
};

/**
 * Order-health stoplight dot (thresholds computed server-side in scheduler /queue).
 * `health` is null when there's no real need date yet (e.g. a cron auto-handoff
 * before capture) — render a neutral dot rather than crash.
 */
export function HealthStoplight({ health }: { health: Health | null }) {
    if (health === null) {
        return (
            <span
                className={`${styles.dot} ${styles.unknown}`}
                role="img"
                aria-label="Health unknown (no need date yet)"
                title="No real need date yet"
            />
        );
    }
    return (
        <span
            className={`${styles.dot} ${styles[health.toLowerCase()]}`}
            role="img"
            aria-label={`Health ${health}: ${LABEL[health]}`}
            title={LABEL[health]}
        />
    );
}
